<ng-container [ngSwitch]="inputType">
  <mat-form-field class="search-input" floatLabel="never" *ngSwitchCase="'dropdown'">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-select (selectionChange)="changeValue($event)" [(ngModel)]="value">
      <mat-option *ngIf="selectedFilter?.search?.callback">
        <ngx-mat-select-search
          [formControl]="searchControl"
          [searching]="selectedFilter?.search.loading"
          placeholderLabel="Search"
          noEntriesFoundLabel="No entry matches"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let option of options"
        [value]="selectedFilter?.search?.filter ? value : option.value"
        [disabled]="option.disabled"
        [ngStyle]="{ display: option.hidden ? 'none' : 'block' }"
        >{{ option.label }}</mat-option
      >
    </mat-select>
  </mat-form-field>
  <mat-form-field class="search-input" floatLabel="never" *ngSwitchDefault>
    <input
      #searchInput
      matInput
      [placeholder]="placeholder"
      [(ngModel)]="value"
      [disabled]="isDisabled()"
      (keyup)="onKeyUp($event)"
      (keyup.enter)="changeValue()"
    />
  </mat-form-field>
</ng-container>
